import { cn } from "../../../libs";

interface CheckboxProps {
  isChecked: boolean;
  className?: string;
}

export function Checkbox({ isChecked, className }: CheckboxProps) {
  return (
    <div
      className={cn(
        "w-5 h-5 rounded border e-center rounded-full",
        className,
        isChecked ? "bg-background-highlight !border-border-dark" : "border-border hover:border-border-dark"
      )}
    >
      {isChecked && <div className="w-3 h-3 bg-background-dark rounded-full"></div>}
    </div>
  );
}
